"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ClassInstanceFormPreviewDialogModule = /** @class */ (function () {
    function ClassInstanceFormPreviewDialogModule() {
    }
    return ClassInstanceFormPreviewDialogModule;
}());
exports.ClassInstanceFormPreviewDialogModule = ClassInstanceFormPreviewDialogModule;
